import { css, Interpolation, Theme } from '@emotion/react'
import { accordionClasses, accordionDetailsClasses, accordionSummaryClasses, buttonBaseClasses } from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const wrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
  margin-bottom: ${theme.spacing(2)};
`

export const label: Interpolation<Theme> = (theme) => css`
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const accordion = (theme: Theme) => css`
  margin: 0;
  padding-bottom: ${theme.spacing(3)};
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${theme.colors.backgroundOne};
  box-shadow: none;

  :first-of-type {
    margin: 0;
  }

  &.${accordionClasses.expanded} {
    margin: 0;
  }

  .${buttonBaseClasses.focusVisible} {
    background-color: transparent;
  }

  :before {
    display: none;
  }
`

export const accordionSummary = css`
  &.${accordionSummaryClasses.root} {
    padding: 0;
    min-height: 0;
    margin: 0;
  }

  & .${accordionSummaryClasses.content} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;

    &.${accordionSummaryClasses.expanded} {
      margin: 0;
    }
  }

  &.${accordionSummaryClasses.focusVisible} {
    background: transparent;
  }
`

export const accordionDetails = (theme: Theme) => css`
  padding: 0;

  &.${accordionDetailsClasses.root} {
    padding: ${theme.spacing(2, 0, 1)};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  }
`

export const title = css`
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
`

export const buttons = css`
  display: flex;
  align-items: center;
`

export const error = (theme: Theme) => css`
  color: ${theme.colors.red};
`

export const iconChevron = (theme: Theme) => css`
  transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
`

export const iconChevronOpen = css`
  transform: rotate(180deg);
`

export const editor = css`
  .text-editor {
    border-radius: 0 0 14px 14px;
    margin: 0 -1px -1px;
  }
`

export const popperList: Interpolation<Theme> = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: 6px;

  padding: ${theme.spacing(1)};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 4)};

  list-style-type: none;

  background-color: ${theme.backgrounds.backgroundFour};
`

export const popperListButton: Interpolation<Theme> = (theme: Theme) => css`
  justify-content: flex-start;

  width: 100%;
  padding: ${theme.spacing(1.25)};
  border: none;
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};

  color: ${theme.colors.typographyTwo};
  font-weight: 500;

  :hover {
    border: none;

    background-color: ${theme.colors.grayHover};
  }
`

export const empty: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyThree};
`
